/* eslint-disable no-useless-catch */
/* eslint-disable consistent-return */
import { resultsConfig } from '@Constants/Results';
import cloneDeep from 'lodash/cloneDeep';
import includes from 'lodash/includes';
import map from 'lodash/map';
import some from 'lodash/some';
import isObject from 'lodash/isObject';
import pick from 'lodash/pick';
import values from 'lodash/values';
import LeastRecentlyUsedMap from './leastrecentlyusedMap';

const CAPACITY = 512;
const keyParts = resultsConfig.CACHE_KEY_PARTS;
const storage = new LeastRecentlyUsedMap(CAPACITY);

const _validateParams = (params) => {
  const containsKeyPart = some(Object.keys(params), (property) => includes(keyParts, property));
  if (!isObject(params) || !containsKeyPart) {
    throw new Error('ResultsCache: invalid params passed as a key');
  }
};

const keyify = (obj, keyPartsDetails) => {
  const picked = keyPartsDetails ? pick(obj, keyPartsDetails) : obj;
  return values(picked).join('/');
};

export const _keyify = (params) => {
  _validateParams(params);
  return keyify(params, keyParts);
};

const _copy = (results) => {
  if (!results) return;
  return map(results, (result) => cloneDeep(result));
};

export const put = (params, results) => {
  try {
    storage.put(_keyify(params), _copy(results));
  } catch (error) {
    throw error;
  }
};

export const get = (params) => {
  try {
    return _copy(storage.get(_keyify(params)));
  } catch (error) {
    throw error;
  }
};
